import { render } from "./TonalityService.vue?vue&type=template&id=0daf0cf4"
import script from "./TonalityService.vue?vue&type=script&lang=js"
export * from "./TonalityService.vue?vue&type=script&lang=js"

import "./TonalityService.vue?vue&type=style&index=0&id=0daf0cf4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__